__turbopack_context__.v({
  "pricesBg": "PricesHero-module__pnJ4VW__pricesBg",
  "pricesHero": "PricesHero-module__pnJ4VW__pricesHero",
});
